import React, {useState} from 'react';
import Button from '~/shared/legacy_presentational-components/Form/Button';
import styles from '../Signup.module.scss';

interface Props {
    isCIS: boolean;
    onApply: () => Promise<void>;
    isPending: boolean;
}

export function Intro({isCIS, onApply, isPending}: Props) {
    const [lang, setLang] = useState('ru');

    const handleChangeLang = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLang(e.target.value);
    };

    return (
        <div className={styles.main_kyc}>
            {!isCIS && (
                <div>
                    <p className={styles.text}>
                        Your account needs to be verified through
                        <br />
                        KYC (Know Your Customer) procedure which
                        <br />
                        is required by the state regulation of European Union.
                    </p>
                    <div className={styles.status_passBig}></div>
                </div>
            )}

            {!!isCIS && (
                <div>
                    <div className={styles.header}>
                        <div className={styles.status_pass}></div>
                        <p className={styles.textSmall}>
                            Your account needs to be verified through
                            <br />
                            KYC (Know Your Customer) procedure which
                            <br />
                            is required by the state regulation of European Union.
                        </p>
                    </div>
                    <div className={styles.notification}>
                        {lang === 'ru' ? (
                            <div>
                                <div className={styles.notification_title}>ВАЖНО</div>
                                <div className={styles.notification_text}>
                                    Если Вы являетесь резидентом страны СНГ,
                                    <br />
                                    подготовьте ваш ЗАГРАНПАСПОРТ
                                    <br />
                                    для завершения процедуры регистрации.
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className={styles.notification_title}>Read me please</div>
                                <div className={styles.notification_text}>
                                    If you are resident of a CIS country <br />
                                    prepare your INTERNATIONAL PASSPORT
                                    <br />
                                    to complete the KYC procedure.
                                </div>
                            </div>
                        )}
                        <div className={styles.notification_switch}>
                            <input
                                type='radio'
                                value='ru'
                                id='ru'
                                name='language'
                                className={styles.radioButton}
                                checked={lang === 'ru'}
                                onChange={handleChangeLang}
                            />
                            <label htmlFor='ru' className={styles.label}>
                                RU
                            </label>
                            <input
                                type='radio'
                                value='en'
                                id='en'
                                name='language'
                                className={styles.radioButton}
                                checked={lang === 'en'}
                                onChange={handleChangeLang}
                            />
                            <label htmlFor='en' className={styles.label}>
                                ENG
                            </label>
                        </div>
                    </div>
                </div>
            )}
            <div style={{marginTop: 'auto'}}>
                <Button onClick={onApply} disabled={isPending} type='button' title='Apply for KYC' />
            </div>
        </div>
    );
}
